import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  cn,
  Loader,
} from '@opoint/infomedia-storybook'
import { Trans } from 'react-i18next'
import { useAppSelector } from '../hooks/useAppSelector'
import { getDeleteAlertInProgress } from '../../selectors/alertsSelectors'
import { useAppDispatch } from '../hooks/useAppDispatch'

type AlertDeleteConfirmationDialogProps = {
  show: boolean
  onClose: () => void
  alertId: number
}

const AlertDeleteConfirmationDialog = ({ alertId, show, onClose }: AlertDeleteConfirmationDialogProps) => {
  const isDeleteInProgress = useAppSelector(getDeleteAlertInProgress)
  const dispatch = useAppDispatch()

  return (
    <AlertDialog open={show}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Trans>Are you sure you want to delete this alert?</Trans>
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans>No alerts will be sent to recipients after deletion. This action is irreversible.</Trans>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleteInProgress} onClick={onClose}>
            <Trans>Cancel</Trans>
          </AlertDialogCancel>
          <AlertDialogAction
            className={cn(isDeleteInProgress && 'text-transparent')}
            data-cy="delete"
            onClick={() => dispatch({ type: 'DELETE_ALERT_CONFIRM', payload: { alertId } })}
          >
            <Trans>Delete</Trans>
            {isDeleteInProgress && <Loader className="absolute border-sky.cloudy/50 border-r-white" size="small" />}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default AlertDeleteConfirmationDialog
